import { ApiError } from "./api.js";

/**
 * Fehlercodes, zu denen die Oberflaeche einen EIGENEN Satz hat.
 *
 * Voreingestellt zeigt diese Funktion die Meldung des Servers — die ist
 * konkret und steht ohnehin in genau einer Sprache. Wo der Grund aber eine
 * Regel der Oberflaeche ist und keine Panne („du hast zu schnell gemeldet",
 * „diese Nummer kennen wir nicht"), gehoert der Satz in beide Sprachdateien:
 * Sonst liest die englische Oberflaeche an genau der Stelle Deutsch, an der
 * der Nutzer etwas tun soll.
 */
const CODE_SCHLUESSEL: Readonly<Record<string, string>> = {
  FEEDBACK_RATE_LIMITED: "feedback.errors.rateLimited",
  FEEDBACK_ISSUE_UNKNOWN: "feedback.errors.issueUnknown",
  FILE_EMPTY: "feedback.screenshot.emptyError",
};

/**
 * Aus einem Fehler einen Satz machen, den ein Mensch lesen kann (Befund B7).
 *
 * Ein fehlgeschlagener Speichervorgang zeigte ein rotes Banner mit genau einem
 * Wort: „Fehler". Die Servermeldung („Simulierter Serverfehler") wurde nicht
 * ausgewertet, ein Grund stand nirgends. Ursache war die Kombination aus einer
 * leeren `message` (bei einer Antwort ohne verwertbaren Körper bleibt nur
 * `statusText`, und der ist bei HTTP/2 leer) und einer Anzeige, die den
 * Meldungstext ungeprüft in ein `Alert` legte, dessen Titel „Fehler" lautete.
 *
 * Deshalb hier: **nie eine leere Meldung** zurückgeben, und die technische
 * Einordnung (Code, Status) sichtbar anhängen. Wer den Fehler meldet, kann ihn
 * damit benennen, statt „da stand Fehler" zu sagen.
 */
export function describeApiError(
  error: unknown,
  t: (key: string) => string,
): string {
  if (error instanceof ApiError) {
    const eigener = error.code ? CODE_SCHLUESSEL[error.code] : undefined;
    const message = (eigener ? t(eigener) : error.message).trim();
    const detail =
      error.code && error.code !== "UNKNOWN"
        ? `${error.code} · HTTP ${error.status}`
        : `HTTP ${error.status}`;
    return `${message.length > 0 ? message : t("common.errorUnexpected")} (${detail})`;
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message.trim();
  }
  return t("common.errorUnexpected");
}
